import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const AnswerOptionInput = styled.input`
  opacity: 0;
  position: fixed;
  width: 0;

  + label {
    appearance: none;
  }

  &:checked + label {
    background-color: ${(props) =>
      props.completed
        ? 'var(--cc_color_utility_success)'
        : 'var(--cc_color_collab_navy)'};
    color: white;
  }
`;

const AnswerOption = ({
  id,
  answerOption,
  index,
  answerChoices = [],
  onChange,
  disabled,
  completed,
  children,
}) => {
  return (
    <div>
      <AnswerOptionInput
        id={id}
        data-testid="subtask-form-answer-choice-input"
        checked={answerChoices?.includes(index)}
        name="answerChoice"
        onChange={() => onChange(index)}
        type="checkbox"
        value={index}
        disabled={disabled}
        completed={completed}
        aria-label={answerOption}
      />
      {children}
    </div>
  );
};

AnswerOption.propTypes = {
  id: PropTypes.string.isRequired,
  answerOption: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  answerChoices: PropTypes.arrayOf(PropTypes.number),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  completed: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default AnswerOption;
